





















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";

import UpdateAgent from "./UpdateAgent.vue";
import CreateAgent from "./CreateAgent.vue";
import CommissionView from "./CommissionView.vue";

@Component({ components: { UpdateAgent, CreateAgent, CommissionView } })
export default class ManageAgent extends Vue {
  @Prop({ default: {} }) agent!: any;
  @Action("updateAgent") updateAgent!: Function;

  manageAgentDialog = false;
  newAgentDialog = false;
  commissionDialog = false;

  get isSelected() {
    return Object.keys(this.agent).length > 0;
  }

  getCloserPriority(agent: any): string {
    return agent.closer_priority || "0";
  }

  clearPriorityOverride() {
    this.updateAgent({
      data: {
        closer_priority_override: null
      },
      userId: this.agent.id,
      notify: true
    });
  }

  toggleManageAgentDialog(value: boolean) {
    this.manageAgentDialog = value;
  }
}
